<template>
  <v-menu
    full-width
    lazy
    offset-y
    min-width="290px"
    transition="scale-transition"
    v-model="showDatePicker"
    :close-on-content-click="false"
    :nudge-right="40"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        clearable
        readonly
        class="mt-0 pt-0"
        prepend-icon="event"
        v-model="formatDate"
        v-on="on"
        @click:clear="clearDatePicker"
        :label="label"
      ></v-text-field>
    </template>
    <v-date-picker
      locale="pt-BR"
      v-model="date"
      @input="showDatePicker = false"
      @change="emitDate"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { formatDate } from "@/utils/date";

export default {
  name: "DatePickerDefault",
  props: {
    label: String
  },
  data() {
    return {
      date: null,
      showDatePicker: false
    };
  },
  computed: {
    formatDate() {
      return this.date && formatDate(this.date);
    }
  },
  methods: {
    clearDatePicker() {
      this.$emit("clear-date", null);
    },
    emitDate() {
      this.$emit("change", this.date);
    }
  }
};
</script>
